<template>
  <div class="d-flex align-center gap-1">
    <v-btn v-for="action in configActions" :key="action.name" v-bind="action.configButton" @click="onClick(action)">
      <v-icon v-if="action.configButton.iconName">
        {{ action.configButton.iconName }}
      </v-icon>
      <span v-if="!action.configButton.iconName">
        {{ action.configButton.title }}
      </span>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    values: [Object],
    model: Object,
  },

  computed: {
    configActions() {
      return this.model?.configActions || [];
    },
  },
  methods: {
    onClick(e) {
      console.log(e);

      let action = e.action;
      if (!action) return;
      let value;
      if (action?.valueType == "eval") {
        value = eval(`(${action.value})`);
        if (value) window.open(value, "_blank");
      }
    },
    actionsArray() {
      return Object.values(this.configActions);
    },
  },
};
</script>
